require('./bootstrap');
require('./util/unique_id');

import IMask from 'imask';

import { Chartisan, ChartisanHooks } from '@chartisan/chartjs';

window.chart_colors = [
    '#ef9a9a',
    '#F48FB1',
    '#CE93D8',
    '#B39DDB',
    '#9FA8DA',
    '#90CAF9',
    '#81D4FA',
    '#80DEEA',
    '#80CBC4',
    '#A5D6A7',
    '#E6EE9C',
    '#FFAB91',
    '#FFCCBC',
    '#D7CCC8',
];

window.getDefaultChartisanHooks = function() {
    return new ChartisanHooks()
        .options({ options: { scales: { xAxes: [{ ticks: { beginAtZero: true } }] } } })
        .datasets('horizontalBar')
        .colors([window.chart_colors])
        .responsive()
        .legend(false)
        .tooltip(false);
}
